import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TuiButtonModule } from "@taiga-ui/core";
import { KwikUIButtonApiCallComponent } from "./button-api-call.component";
import { KwikUIMessagesModule } from "../messages/messages.module";

@NgModule({
  declarations: [KwikUIButtonApiCallComponent],
  imports: [CommonModule, KwikUIMessagesModule, TuiButtonModule],
  exports: [KwikUIButtonApiCallComponent]
})
export class KwikUIButtonApiCallModule {}
